const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(unauthenticated)/export/v1/loop-visualization/dashboard/$dashboardId/pdf/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { internalDashboardExportSearchSchema } from '@/features/views/components/export/ExportDashboardPage';
export const Route = createFileRoute('/(unauthenticated)/export/v1/loop-visualization/dashboard/$dashboardId/pdf')({
  validateSearch: zodValidator(internalDashboardExportSearchSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});